const getExtension = function(file) {
  if (file.name) {
    const filename = file.name
    let possibleExtension = filename.substr((Math.max(0, filename.lastIndexOf('.')) || Infinity) + 1)
    if (possibleExtension == '') {
      return possibleExtension
    }
    // remove query string
    possibleExtension = possibleExtension.replace(/\?.*$/, '')
    // if there are special characters, this is not an extension
    if (possibleExtension.match(/[^a-zA-Z0-9]/)) {
      return ''
    } else {
      return possibleExtension.toLowerCase()
    }
  } else if (file.type) {
    // return png for image/png
    const [mimeType, charset] = file.type.split(';')
    const [mimeTypeWithoutPlus, _] = mimeType.split('+')
    const [mimeCategory, possibleExtension] = mimeType.split('/')
    if (possibleExtension) {
      return possibleExtension.toLowerCase()
    } else {
      return ''
    }
  }
}

const getName = function(file) {
  const ext = getExtension(file)
  if (file.name) {
    const filename = file.name
    const splits = filename.split('.')
    let extension = splits.pop()
    let baseFilename = splits.join('_')
    // cleanup special characters. They create problems
    baseFilename = baseFilename.replace(/[^a-zA-Z0-9_]/g, '_')
    // limit length
    baseFilename = baseFilename.substr(0, 100)

    if (ext) {
      return [baseFilename, ext].join('.')
    } else {
      return baseFilename
    }
  } else if (ext) {
    return `file.${ext}`
  } else {
    return 'file'
  }
}

const getEmbeddedUrl = function(file) {
  return new Promise((resolve, reject) => {
    const extension = getExtension(file)
    if (extension.match(/gdoc|gsheet|glink|gform|gmap|gmaps|gslides|gdraw|url|htm|html|webloc|mht|mhtml/)) {
      var matches
      const reader = new FileReader()
      reader.onload = () => {
        const text = reader.result
        if (
          extension === 'gdoc' ||
          extension === 'gsheet' ||
          extension === 'glink' ||
          extension === 'gform' ||
          extension === 'gmap' ||
          extension === 'gmaps' ||
          extension === 'gslides' ||
          extension === 'gdraw'
        ) {
          const hash = JSON.parse(text)
          resolve({ url: hash.url })
        } else if (extension === 'url' && (matches = text.match(/URL=(.*)/))) {
          resolve({ url: matches[1] })
        } else if (
          (extension === 'htm' || extension === 'html') &&
          text.indexOf('window.googleJavaScriptRedirect') >= 0 &&
          (matches = text.match(/content="0;URL='(.*)'/))
        ) {
          resolve({ url: matches[1] })
        } else if (
          (extension === 'htm' || extension === 'html') &&
          (matches = text.match(/<\!\-\-\ssaved\sfrom\surl=\((?:\d+)\)(.*?)\s\-\-\>/)) &&
          matches[1] !== 'http://tiddlywiki.com'
        ) {
          resolve({ url: matches[1] })
        } else if (extension === 'webloc' && (matches = text.match(/<string>(.*)<\/string>/))) {
          resolve({ url: matches[1] })
        } else if (
          (extension === 'mht' || extension === 'mhtml') &&
          (matches = text.match(/Content\-Location\:\s(.*)/))
        ) {
          resolve({ url: matches[1] })
        } else {
          reject()
        }
      }
      reader.onerror = () => {
        reject()
      }
      reader.readAsText(file)
    } else {
      reject()
    }
  })
}

export { getExtension, getName, getEmbeddedUrl }
